import { useEffect, useMemo } from 'react';
import { filterOptionsInitialState, getIndexOfFoundStatus } from '../../utils/listingStatus';
import { AdInterface } from '../contexts/types/ad';
import { useListingFilterContext } from '../contexts/listingFilter';
import { STATUS } from '../../enum/listing-status';
import { useListing } from '../../hooks/useListing';

interface UseFilterReturn {
  listingFiltered?: AdInterface[];
  filterOptions?: (
    | {
        name: string;
        text: string;
        value: number;
        statusIds: undefined;
      }
    | {
        name: string;
        text: string;
        value: number;
        statusIds: number[];
      }
  )[];
}

interface FilterReducer {
  name: string;
  text: string;
  value: number;
  statusIds?: number[];
}

export function useFilter(): UseFilterReturn {
  const { listing } = useListing();
  const { selectedOption, setSelectedOption } = useListingFilterContext();
  const listingFiltered = useMemo(() => {
    if (!listing) return;
    const findType = filterOptionsInitialState.find(item => item.name === selectedOption);
    switch (selectedOption) {
      case STATUS.incomplete:
        return listing.filter(item => item.filterName === STATUS.incomplete);
      case STATUS.all:
        return listing;
      case STATUS.waiting:
        return listing.filter(item => item.filterName === STATUS.waiting);
      default:
        return listing.filter(item => item.filterName === findType?.name);
    }
  }, [selectedOption, listing]);

  useEffect(() => {
    if ((listingFiltered == null || listingFiltered.length == 0) && selectedOption != 'all') {
      setSelectedOption('all');
    }
  }, [listingFiltered, selectedOption, setSelectedOption]);

  const filterOptions = listing?.reduce<FilterReducer[]>((acc, item) => {
    if (!item?.filterName) return acc;
    switch (item.filterName) {
      case STATUS.incomplete:
        return [
          ...acc.map(option => {
            if (option.name === STATUS.incomplete || option.name === 'all') {
              return {
                ...option,
                value: option.value + 1
              };
            }
            return option;
          })
        ];
      case STATUS.waiting:
        return [
          ...acc.map(option => {
            if (option.name === STATUS.waiting || option.name === 'all') {
              return {
                ...option,
                value: option.value + 1
              };
            }
            return option;
          })
        ];
      default:
        return [
          ...acc.map(option => {
            if (
              option.name === acc[getIndexOfFoundStatus(item?.filterName)].name ||
              option.name === 'all'
            ) {
              return {
                ...option,
                value: option.value + 1
              };
            }
            return option;
          })
        ];
    }
  }, filterOptionsInitialState as FilterReducer[]);

  return {
    filterOptions,
    listingFiltered
  };
}
